<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          {{ $t(create
            ? 'Добавление договора'
            : 'Редактирование договора') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-progress-linear v-if="isLoading" color="loader" indeterminate class="mt-2" />
      <general-error v-if="!!generalError" />
      <v-card-text class="pt-2">

        <ValidationObserver ref="contractForm">
          <validatable-text-input
              v-model="contract.contractNumber"
              :rules="{ required: true,
                        max: 12,
                        regex: /^\d{1,11}(У|у)(Е|е)$/ }"
              :label="$t('Номер договора')"
              prepend-icon="" />
          <validatable-date-picker
              v-model="contract.contractDate"
              rules="required"
              :label="$t('Дата договора')" />
          <validatable-date-picker
              v-if="create"
              v-model="contract.paymentDate"
              rules="required"
              :label="$t('Дата оплаты договора')" />
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="saveBtn"
            v-test="{ btn: 'save' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="sendRequest">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'
  import { mapActions } from 'vuex'
  import { ORGANIZATION_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      ValidatableDatePicker,
      ValidatableTextInput,
      GeneralError
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => ({
          show: false,
          organizationId: null,
          contractInfo: {
            contractNumber: null,
            contractDate: null,
            paymentDate: null
          },
          callback: () => {}
        })
      }
    },
    data () {
      return {
        isLoading: false,
        contract: {
          contractNumber: null,
          contractDate: null,
          paymentDate: null
        }
      }
    },
    computed: {
      create () {
        return !this.dialogProp.contractInfo.contractNumber
      }
    },
    watch: {
      'dialogProp.contractInfo': {
        immediate: true,
        handler (newValue, oldValue) {
          if (newValue && newValue !== oldValue) {
            if (!this.create) {
              this.contract.contractNumber = newValue.contractNumber
              this.contract.contractDate = newValue.contractDate
              this.contract.paymentDate = newValue.paymentDate
            }
          }
        }
      }
    },
    methods: {
      ...mapActions(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        createOrganizationContractAction: ORGANIZATION_MANAGEMENT.ACTIONS.CREATE_ORGANIZATION_CONTRACT,
        updateOrganizationContractAction: ORGANIZATION_MANAGEMENT.ACTIONS.UPDATE_ORGANIZATION_CONTRACT
      }),
      sendRequest: async function () {
        try {
          const result = await this.$refs.contractForm.validate()

          if (!result) {
            throw new Vue.errorsTypes.ValidationError()
          }
          const model = {
            contract: this.contract,
            organizationId: this.dialogProp.organizationId
          }

          this.isLoading = true
          if (this.create) {
            await this.createOrganizationContractAction(model)
          } else {
            await this.updateOrganizationContractAction(model)
          }

          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
